import { html } from 'lit';
const TranscriptWithAi =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M17.25 11.5a.54.54 0 0 0-.538.48c-.107.923-.378 1.536-.787 1.945s-1.022.68-1.945.787a.542.542 0 0 0 0 1.076c.908.103 1.536.375 1.956.788.417.409.694 1.02.774 1.93a.542.542 0 0 0 1.08-.001c.077-.895.353-1.52.774-1.941.42-.42 1.046-.697 1.941-.774a.542.542 0 0 0 .001-1.08c-.91-.08-1.521-.357-1.93-.774-.413-.42-.685-1.048-.788-1.955a.54.54 0 0 0-.537-.481" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M3 7.75A2.75 2.75 0 0 1 5.75 5h11a2.75 2.75 0 0 1 2.75 2.75v2a.75.75 0 0 1-1.5 0v-2c0-.69-.56-1.25-1.25-1.25h-11c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h7a.75.75 0 0 1 0 1.5h-7A2.75 2.75 0 0 1 3 15.75z" clip-rule="evenodd"/><path fill='currentColor' fill-rule="evenodd" d="M6.5 9.75A.75.75 0 0 1 7.25 9h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75M6.5 12.75a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
export default TranscriptWithAi;
